import React from 'react';

//MUI components
import Grid from '@mui/material/Grid';
import YoutubeSearchedForTwoToneIcon from '@mui/icons-material/YoutubeSearchedForTwoTone';
import {Typography} from '@mui/material';

const SearchError = () => {
  return (
    <Grid container justifyContent="center" alignItems="center" direction="column" style={{padding: '0 0 24px 0'}}>
      <YoutubeSearchedForTwoToneIcon color="primary" style={{fontSize: 64, marginTop: 48}} />
      <Typography variant="h5" style={{marginTop: 18}}>
        Sorry, there are problems with performing the search. Please try again.
      </Typography>
    </Grid>
  );
};

export default SearchError;
